import Flex from "../../../../components/Flex";
import { Box, Paper } from "@mui/material";
import AddSuperBill from "./UpsertSuperBill";
import SuperBillHeader from "./SuperBillHeader";
import PatientDetailsSideSection from "./PatientDetailsSideSection";
import { useGetPatient } from "../../../../queries/use-get-patient-uuid";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { useGetSuperBill } from "../../../../queries/billings/use-get-super-bill";
import { getIdFromObj, getXtenantId } from "@/utils/utils";
import { useRenderingProviderInfo } from "./use-rendering-provider-info";
import { useFormik } from "formik";
import * as Yup from "yup";

const UpdateSuperBillingLayout = () => {
  // patientId encounterId

  const { patientId, superBillId } = useParams();

  // const [patientid, setPatientid] = useState(patientId);
  const { data: patientDataBillDetails } = useGetSuperBill({
    superBillUuid: superBillId ?? "",
    xTENANTID: getXtenantId(),
  });

  const isPatientResponsibilityInvoice =
    patientDataBillDetails?.data?.patientResponsibilityInvoice === true;

  // Source Rendering Provider Details (NPI / License TX from the provider
  // record) so screen and Invoice Report stay in sync.
  const renderingProviderInfo = useRenderingProviderInfo(
    patientDataBillDetails?.data
  );

  const patientValidationFormik = useFormik({
    initialValues: {
      patient: patientId,
    },
    validationSchema: Yup.object({
      patient: Yup.string().required().label("Patient"),
    }),
    enableReinitialize: true,
    onSubmit: () => {},
  });

  const { data: patientData } = useGetPatient(
    patientValidationFormik?.values?.patient
  );
  const [total, setTotal] = useState(0);

  return (
    <Flex height={"calc(100vh - 4.4rem)"} p={1.8}>
      <Flex
        flexDirection={"column"}
        width={"80%"}
        minHeight={"calc(100vh - 60px)"}
        gap={1}
      >
        <Paper
          sx={{
            height: "auto",
            p: 1.2,
            boxSizing: "border-box",
            overflow: "clip",
          }}
        >
          <SuperBillHeader
            patientValidationFormik={patientValidationFormik}
            patientsData={patientData}
            // setPatientId={setPatientid}
            viewBill={false}
            title={
              isPatientResponsibilityInvoice
                ? "Edit Invoice for Patient Responsibility"
                : "Edit Invoice"
            }
          />
        </Paper>
        <Box p={0.3} height={"auto"} overflow="auto">
          <AddSuperBill
            patientValidationFormik={patientValidationFormik}
            patientsData={patientData}
            patientDataBillDetails={patientDataBillDetails?.data}
            viewBill={true}
            superBillId={superBillId}
            totalAmount={total}
            setTotal={setTotal}
            isPatientResponsibilityInvoice={isPatientResponsibilityInvoice}
          />
        </Box>
      </Flex>
      <Box width={"20%"} height="inherit">
        <Paper
          sx={{
            height: "inherit",
            p: 1.2,
            boxSizing: "border-box",
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <PatientDetailsSideSection
            patientsData={patientData}
            viewBill={true}
            total={total}
            visitId={getIdFromObj(patientDataBillDetails?.data?.encounter)}
            // Always show Rendering Provider Details on the invoice
            // screen (not only for patient-responsibility invoices), to match
            // the Invoice Report.
            renderingProviderInfo={renderingProviderInfo}
          />
        </Paper>
      </Box>
    </Flex>
  );
};

export default UpdateSuperBillingLayout;
